<template>
  <div
    class="rich-text-editor"
    :id="blockId"
    :ref="blockId"
    :style="blockStyle"
  >
    <div
      v-html="clickableValue"
      :class="{
        'hidden': isDefaultText
      }"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import anchorme from 'anchorme'
import util from '../../../util'

export default {
  components: {
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    slideId: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slide,
      presentation: (state) => state.presentation,
      showHyperLink: (state) => state.presentation.showHyperLink,
    }),

    isDefaultText() {
      const textContent = util.extractContent(this.value, true)
      return textContent && textContent.includes('Click to add')
    },

    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },

    clickableValue() {
      let replaceValue = this.value
      if (!replaceValue) {
        replaceValue = ''
      }

      replaceValue.trim()

      if (!this.showHyperLink) {
        replaceValue = replaceValue.replace(/<a/g, '<span')
        replaceValue = replaceValue ? replaceValue.replace(/text-hyper-link/g, '') : this.value
        // Remove Zero-Width Space
        replaceValue = replaceValue.replace(/[\u200B-\u200D\uFEFF]/g, '')
        return replaceValue
      }

      if (replaceValue.indexOf('data-mce-href=') !== -1) {
        replaceValue = replaceValue ? replaceValue.replaceAll('data-mce-href=', 'class="text-hyper-link" target="_blank" href=') : replaceValue
      }

      return anchorme(replaceValue, {
        attributes: [
          {
            name: 'target',
            value: 'blank',
          },
          {
            name: 'class',
            value: 'text-hyper-link',
          },
        ],
      })
    },
  },

  created() {

  },

  mounted() {

  },

  beforeDestroy() {
  },

  destroyed() {
  },

  methods: {

  },

}

</script>

<style lang="scss" scoped>

.rich-text-editor {
  overflow: hidden;
  font-size: 2rem;
  min-height: 42px;
  padding: 10px;
  min-width: 42px;

  -webkit-user-select: text; // Fix bug: editor doesn't work on Safari
  cursor: text;
  line-height: 1.2;
  &.is-disabled {
    border: none;
    cursor: default;
  }
  &:hover {
    overflow-y: auto;
  }

  &::v-deep img {
    outline: none !important;
  }

  &::v-deep p {
    margin: 0;
  }

}

.slide-container {
  .freestyle-canvas-content {
    .clickable {
      ::v-deep .text-hyper-link{
        &:hover{
          text-decoration: underline !important;
        }
        text-decoration: underline;
        pointer-events: inherit;
        color: inherit;
      }
    }
    .is-sharing.mce-content-body {
      ::v-deep [data-mce-selected="inline-boundary"]{
        background-color: inherit;
      }
    }
  }
}

</style>
